import { FC, useEffect, useState } from "react";
import { useOrder } from "../../hooks/useOrder";
import styles from "./index.module.css";
import { capitalizeFirstLetter } from "../../functions/util";
import { cpfMask, telephoneToMask } from "../../functions/mask";
import { useCustomer } from "../../contexts/customerContext/customerContext";

type Customer = {
  id: number;
  name: string;
  email: string;
  doc: string;
  password: null;
  pluginspaceId: number;
  hash: null;
  type: string;
  created: string;
  updated: string;
  cpf: string;
  inscEstadual: string;
  optinWhatsapp: boolean;
  birthDate: string;
  gender: string;
  lgpdDataAceiteCarta: string;
  customerCode: null;
  idTerms: null;
  deleted: null;
  customerAddresses: CustomerAddress[];
  customerPhones: CustomerPhone[];
  branchInsertCode: number;
  classifications: null;
  isInactive: boolean;
  customerStatus: string;
};

type CustomerPhone = {
  id: number;
  customerId: number;
  typePhone: string;
  numberPhone: string;
};

type CustomerAddress = {
  id: number;
  customerId: number;
  typeAddress: string;
  street: string;
  extra: null | string;
  number: string;
  district: string;
  city: string;
  reference: null;
  state: string;
  zipCode: string;
  country: string;
  ibgeCode: number;
  latlng: Latlng;
  placeId: string;
  created: string;
  updated: string;
};

type Latlng = {
  lat: number;
  lng: number;
};

const InfoCustomer: FC = () => {
  const { customer, customerAddress } = useCustomer();

  return (
    <div className={styles.content}>
      <h4>Meus Dados</h4>
      <div className={styles.customer_order_details}>
        <span>{capitalizeFirstLetter(customer?.name)}</span>
        <span>{customer?.cpf}</span>
        <span>{customer?.email}</span>
        <span>
          {telephoneToMask(customer?.phone ? customer?.phone : "")}
        </span>

        {/*Endereço do Cliente */}
        <span>{capitalizeFirstLetter(customerAddress?.street)},{customerAddress?.number},{capitalizeFirstLetter(customerAddress?.neighborhood)}</span>
        <span>{capitalizeFirstLetter(customerAddress?.city)}, {customerAddress?.state}</span>
      </div>
    </div>
  );
};

type Props = {
  customer?: Customer;
};

const InfoCustomerFinish: FC<Props> = ({ customer }) => {
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState<CustomerAddress>();

  function loadCustomer() {
    try {
      if (customer) {
        if (customer.customerPhones.length) {
          setPhone(customer.customerPhones[0].numberPhone);
        }

        if (customer.customerAddresses.length) {
          setAddress(customer.customerAddresses[0]);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    loadCustomer();
  }, []);

  return (
    <div className={styles.content}>
      <h4>Meus Dados</h4>
      <div className={styles.customer_order_details}>
        <span>{capitalizeFirstLetter(customer?.name)}</span>
        <span>{cpfMask(customer?.cpf)}</span>
        <span>{customer?.email}</span>
        <span>{telephoneToMask(phone ? phone : "")}</span>

        {/*Endereço do Cliente */}
        <span>
          {capitalizeFirstLetter(address?.street)},{address?.number},
          {capitalizeFirstLetter(address?.district)}
        </span>
        <span>
          {capitalizeFirstLetter(address?.city)}, {address?.state}
        </span>
      </div>
    </div>
  );
};

export { InfoCustomer, InfoCustomerFinish };
